<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section pay-section">
        <div class="wrapper">
          <ValidationObserver v-slot="{ handleSubmit }" ref="card_form">
            <form @submit.prevent="handleSubmit(onCardSubmit)">
              <div class="cart-up">
                <div class="topup-form">
                  <!-- Card Number -->
                  <label>
                    <div class="desc">Email:</div>
                    <input type="email" placeholder="Email" v-model="email" />
                  </label>
                  <label>
                    <div class="desc">Amount:</div>
                    <input
                      @input="allowOnlyNumbers"
                      type="text"
                      placeholder="amount"
                      v-model="amount"
                    />
                    <div class="desc desc-curr">
                      {{ $parent.currency }}
                    </div>
                  </label>

                  <!-- <label class="label input-container">
                    <div class="desc">Phone (optional):</div>
                    <ValidationProvider name="phone" v-slot="{ errors }">
                      <input
                        type="number"
                        placeholder="Phone"
                        :value="phone"
                        @input="onPhoneInput"
                      />
                      <span v-if="errors[0]" class="error">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </label> -->
                  <label class="label input-container">
                    <div class="desc">Card number</div>
                    <ValidationProvider name="formattedPan" v-slot="{ errors }">
                      <input
                        type="text"
                        placeholder="Card number"
                        :value="formattedPan"
                        @input="onCardNumberInput"
                      />
                      <span v-if="errors[0]" class="error">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </label>

                  <!-- Expiration Date -->
                  <label class="label input-container">
                    <div class="desc">Expiration Date (MM/YY)</div>
                    <ValidationProvider
                      name="expiration_date"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        placeholder="MM/YY"
                        :value="expiration_date"
                        @input="onExpirationInput"
                      />
                      <span v-if="errors[0]" class="error">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </label>

                  <!-- Card Holder Name -->
                  <label class="label input-container">
                    <div class="desc">Card Holder Name</div>
                    <ValidationProvider
                      name="card_holdername"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        placeholder="Card Holder Name"
                        :value="card_holdername"
                        @input="onCardHolderInput"
                      />
                      <span v-if="errors[0]" class="error">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </label>

                  <!-- CVV -->
                  <label class="label input-container">
                    <div class="desc">CVV</div>
                    <ValidationProvider name="card_cvv" v-slot="{ errors }">
                      <input
                        type="password"
                        placeholder="CVV"
                        :value="card_cvv"
                        @input="onCvvInput"
                      />
                    </ValidationProvider>
                  </label>

                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="desc">I agree with </span>
                        <a @click="$parent.goToPrivacy()" class="desc">
                          privacy policy</a
                        >
                        <span class="desc"> and </span>
                        <a @click="$parent.goToTerms()" class="desc">
                          terms and conditions</a
                        >
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div class="cart-bottom">
                <button
                  type="submit"
                  :class="[
                    'button red',
                    { disabled: !requiredRegisterFieldsAreFilled },
                  ]"
                >
                  <span v-if="!loaded">Pay</span>
                  <span v-if="loaded" class="loader"></span>
                </button>
                <div class="desc red">
                  {{ mainError }}
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      formattedPan: "",
      expiration_date: "",
      card_holdername: "",
      card_cvv: "",
      loaded: false,
      email: "",
      phone: "",
      nickname: "",
      terms: false,
      mainError: "",
      amount: "",
    };
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (this.terms) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },

  mounted() {
    this.getProfileData();
  },
  methods: {
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");

      // Split the input into integer and decimal parts
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      // Limit decimal part to two digits
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      // Concatenate the integer and decimal parts back
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    getProfileData() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.email = res.data.email;
          this.phone = res.data.phone;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    // =======================
    // Format/Sanitize Helpers
    // =======================
    formatCardCvv(value) {
      value = value.replace(/\D/g, "");
      return value.slice(0, 3);
    },
    formatCardNumber(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 16) value = value.slice(0, 16);
      return value.replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    formatExpirationDate(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 4) value = value.slice(0, 4);
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      const [month] = value.split("/");
      if (month && parseInt(month, 10) > 12) {
        value = "12" + value.slice(2);
      }
      return value;
    },
    formatCardHolderName(value) {
      value = value.replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ");
      const words = value.trim().split(" ");
      if (words.length > 2) value = words.slice(0, 2).join(" ");
      return value.toUpperCase();
    },

    // Input Handlers
    onCardNumberInput(e) {
      const masked = this.formatCardNumber(e.target.value);
      this.formattedPan = masked;
    },

    onPhoneInput(e) {
      this.phone = e.target.value;
    },
    onExpirationInput(e) {
      this.expiration_date = this.formatExpirationDate(e.target.value);
    },
    onCardHolderInput(e) {
      this.card_holdername = this.formatCardHolderName(e.target.value);
    },
    onCvvInput(e) {
      const masked = this.formatCardCvv(e.target.value);
      this.card_cvv = masked;
    },

    // Submit Handler
    async onCardSubmit() {
      try {
        const [expiry_month, expiry_year] = this.expiration_date.split("/");

        const formData = {
          card_number: this.formattedPan.replace(/\s+/g, ""),
          expiry_month,
          expiry_year,
          cardholder_name: this.card_holdername,
          cvv: this.card_cvv,
          email: this.email,
          phone: this.phone,
          nickname: this.nickname,
          amount: this.amount,
        };

        const combinedData = formData;

        this.loaded = true;
        if (this.email) {
          const res = await this.$http.post(
            process.env.VUE_APP_API + `deposit/execute`,
            combinedData,
          );
          if (res.data.status == "ERROR" && res.data.message) {
            this.loaded = false;
            this.$refs.card_form.setErrors({
              card_cvv: res.data.message,
            });
          } else {
            this.loaded = false;
            window.location = res.data.redirect_url;
          }
        } else {
          const res = await this.$http.post(
            process.env.VUE_APP_API + `orders/checkout/execute`,
            combinedData,
          );
          if (res.data.status == "ERROR" && res.data.message) {
            this.loaded = false;
            this.$refs.card_form.setErrors({
              card_cvv: res.data.message,
            });
          } else {
            this.loaded = false;
            window.location = res.data.redirect_url;
          }
        }
      } catch (error) {
        this.loaded = false;
        let self = this;
        if (error.response) {
          if (error.response.data.errors) {
            const firstErrors = {};
            console.log(error.response.data.errors);
            for (const key in error.response.data.errors) {
              if (
                Object.prototype.hasOwnProperty.call(
                  error.response.data.errors,
                  key,
                ) &&
                Array.isArray(error.response.data.errors[key]) &&
                error.response.data.errors[key].length > 0
              ) {
                firstErrors[key] = error.response.data.errors[key][0];
                self.mainError = firstErrors[key];
              }
            }
          } else if (
            error.response.data.status === "ERROR" &&
            error.response.data.message
          ) {
            this.mainError = error.response.data.message;
          } else {
            this.mainError = error.response.data.message;
          }
        }
      }
    },
  },
};
</script>
